import { Component } from '@angular/core';
import { EventEmitterService } from '../../global_services/event-emitter.service';
import { AuthenticationService } from '../_services';
import { Globals } from 'src/shared/globals';
declare var jquery: any;
declare var $: any;

@Component({
    selector: 'header-app',
    templateUrl: './_header.html',
    standalone: false
})
export class HeaderComponent {
  constructor(
    private eventEmitterService: EventEmitterService,
    private userService: AuthenticationService,
    private global: Globals
  ) {}

  // tslint:disable-next-line: variable-name
  header_control1 = false;
  // tslint:disable-next-line: variable-name
  header_control2 = false;
  UserName = '';
  ImageUrl = '';
  LogoUrl = '';
  // tslint:disable-next-line: use-lifecycle-interface
  ngOnInit() {
      this.LogoUrl = this.global.hostUrl + 'api/Images/Image?upload=/application/images/custom/matti.jpg&size=50x50&quality=100';
    if (this.eventEmitterService.subsVar === undefined) {
      this.eventEmitterService.subsVar = this.eventEmitterService.invokeHeaderComponentFunction.subscribe(
        (name: string) => {
          this.InitiateHeaderFunction();
        }
      );
    }
    this.InitiateHeaderFunction();
  }

  InitiateHeaderFunction(): void {
    try {
      const userString = localStorage.getItem('currentUser');
      if (userString && userString !== 'undefined' && userString !== 'null') {
        const applicationUser = JSON.parse(userString);
        if (applicationUser) {
          this.UserName = applicationUser.FirstName || 'User';
          this.ImageUrl = applicationUser.ImageUrl || '/assets/images/default-avatar.png';
          this.header_control2 = true;
          this.header_control1 = false;
        } else {
          this.setGuestState();
        }
      } else {
        this.setGuestState();
      }
    } catch (e) {
      console.error('Error parsing currentUser from localStorage', e);
      this.setGuestState();
    }
    this.BindEvent();
    this.BindStickyHeader();
  }

  private setGuestState() {
    this.header_control1 = true;
    this.header_control2 = false;
    this.UserName = '';
    this.ImageUrl = '';
  }

  BindEvent() {
    setTimeout(() => {
      // fat arrow
      $('.user-menu').on('click', function() {
        $(this).toggleClass('active');
      });
    });
  }

  Logout(): void {
    this.userService.logout();
    setTimeout(() => {
      this.InitiateHeaderFunction();
    });
  }

  BindStickyHeader() {
    const headerOffset = $('#header-container').height() * 2;
    // tslint:disable-next-line: only-arrow-functions
    $(window).scroll(function() {
      if ($(window).scrollTop() >= headerOffset) {
        $('#header.cloned')
          .addClass('sticky')
          .removeClass('unsticky');
      } else {
        $('#header.cloned')
          .addClass('unsticky')
          .removeClass('sticky');
      }
      hideDD();
    });

    $('.user-menu').on('click', function(event) {
      $('.user-menu')
        .not(this)
        .removeClass('active');
      if (
        $(event.target)
          .parent()
          .parent()
          .attr('class') == 'options'
      ) {
        hideDD();
      } else {
        if ($(this).hasClass('active') && $(event.target).is('span')) {
          hideDD();
        } else {
          $(this).toggleClass('active');
        }
      }
      event.stopPropagation();
    });
    $(document).on('click', function(e) {
      if (
        !$(e.target)
          .parent()
          .hasClass('user-menu')
      ) {
        hideDD();
      }
    });

    function hideDD() {
      $('.user-menu').removeClass('active');
    }
  }
}
